// import Rx from 'rxjs/Rx'
// import {Observable} from 'rxjs'
import { Record } from "immutable";
import { assign } from "lodash";
// import Cookies from 'universal-cookie'
import { INIT } from "../../constants/phase";

import { combineEpics } from "redux-observable";

import * as api from "./api";

/***********************************
 * Action Types
 ***********/
// const cookies = new Cookies()

export const CREATE_DRIVER = "empire/customer/CREATE_DRIVER";
export const DRIVER_DETAILS = "empire/customer/DRIVER_DETAILS";
export const NUMBER_PLATE_DETAILS ="empire/customer/NUMBER_PLATE_DETAILS"

/***********************************
 * Initial State
 ***********/

// Unlike other ducks we are taking a class style approach
// for creating the InitialState. This is becuase we need to fetch the
// locally stored token in the constructor when it is created
const InitialStateInterface = {
  // We need this here to tell InitialState that there is a token key,
  // but it will be reset below to what is in localStorage, unless a value
  // is passed in when the object is instanciated
  data: {},
  token: null,
  phase: INIT,
  userPhase: INIT,
  user: null,
  error: null,
  message: null,
  loginPhase: INIT,
  sendVerificationCodePhase: INIT,
  sendVerificationCodeData: {}
};

class InitialState extends Record(InitialStateInterface) {
  constructor(desiredValues) {
    // When we construct InitialState, we automatically update it's default value
    // for token to be what is stored in localStorage
    const token = ""; // localStorage.getItem(Config.LocalStorageKeys.Authorization)
    super(assign({ token }, desiredValues));
  }
}

/***********************************
 * Reducer
 ***********/
// eslint-disable-next-line complexity, max-statements

export default function (state = new InitialState(), action = {}) {
  switch (action.type) {
    default: {
      return state;
    }
  }
}

/***********************************
 * Action Creators
 ***********/

export const createDriver = payload => {
  return {
    type: CREATE_DRIVER,
    payload: api.createDriver(payload)
  };
};

export const driverDetails = payload => {
  return {
    type: DRIVER_DETAILS,
    payload: api.driverDetails(payload)
  };
};
export const numberPlateDetails = payload => {
  return {
    type: NUMBER_PLATE_DETAILS,
    payload: api.numberPlateDetails(payload)
  };
};
/***********************************
 * Epics
 ***********************************/

export const driverEpic = combineEpics();
